import { Menu, Transition } from "@headlessui/react";
import { Fragment, useEffect, useRef, useState } from "react";
import { MdOutlineFilterAlt } from "react-icons/md";
import { Activities_Search } from "../../generated/graphql";

interface props {
  filter: Activities_Search | null;
  handleFilter: (value: Activities_Search | null) => void;
}

export default function FilterRecentActivities({
  handleFilter,
  filter,
}: props) {
  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button className="p-1 ">
          <MdOutlineFilterAlt color="#4285F4" size={24} />
        </Menu.Button>
      </div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white dark:bg-[#010A18] text-gray-900 dark:text-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none border ">
          <div className="px-1 py-1 ">
            <Menu.Item>
              {({ active }) => (
                <button
                  className={`${
                    active || filter === Activities_Search.All
                      ? "bg-[#B7D0FB] text-gray-900"
                      : ""
                  } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                  onClick={() => handleFilter(Activities_Search.All)}
                >
                  See All
                </button>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <button
                  className={`${
                    active || filter === Activities_Search.Interaction
                      ? "bg-[#B7D0FB] text-gray-900"
                      : ""
                  } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                  onClick={() => handleFilter(Activities_Search.Interaction)}
                >
                  Clinic Activities
                </button>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <button
                  className={`${
                    active || filter === Activities_Search.TaskInteraction
                      ? "bg-[#B7D0FB] text-gray-900"
                      : ""
                  } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                  onClick={() =>
                    handleFilter(Activities_Search.TaskInteraction)
                  }
                >
                  Questionnaire
                </button>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
